import axios from 'axios';
import actions from './actions';

const fetchObservations = (start, end) => (dispatch, getState) => {
  axios.get(`/api/observations?startDate=${start.format('YYYY-MM-DD')}&endDate=${end.format('YYYY-MM-DD')}`).then(res => {
    const observations = res.data;
    axios.get('/api/observations-metadata').then(res => {
      const metadata = res.data;
      dispatch(actions.fetchObservations(observations, metadata, start, end));
    }).catch(err => {
      dispatch(actions.fetchObservationsError(err));
    });
  }).catch(err => {
    dispatch(actions.fetchObservationsError(err));
  });
};

const clearObservations = () => (dispatch, getState) => {
  dispatch(actions.clearObservations());
};

export default{
  fetchObservations,
  clearObservations,
}



// WEBPACK FOOTER //
// ./src/redux/observations/operations.js